import { isValidDateString } from '@/common/utils/dateValidator'
import { z } from 'zod'

export const updateCompanyClientSinceSchema = z.object({
  client_since: z
    .string({ message: 'Campo obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato DD/MM/AAAA' })
    .refine(isValidDateString, { message: 'Data inválida' }),
})

export type UpdateCompanyClientSinceSchema = z.infer<typeof updateCompanyClientSinceSchema>
